import { LocationDetailForm } from "@/features/location/detail/LocationDetailForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { DetailContent } from "@/features/ui/detail/DetailContent";
import { DetailField } from "@/features/ui/detail/DetailField";
import { DetailHeader } from "@/features/ui/detail/DetailHeader";
import { DetailInformTitle } from "@/features/ui/detail/DetailInformTitle";
import { DetailLabel } from "@/features/ui/detail/DetailLabel";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { DetailLinkWrapper } from "@/features/ui/detail/DetailLinkWrapper";
import { DetailTitle } from "@/features/ui/detail/DetailTitle";
import DatetimeUtil from "@/utils/dateTimeUtil";
import { Space } from "@mantine/core";
import { OperationsGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useTranslation } from "react-i18next";

const DetailOperation = Object.assign(DetailHeader, {
  Title: DetailTitle,
  Inform: DetailInformTitle,
  Field: DetailField,
  Label: DetailLabel,
  Link: DetailLink,
  LinkWrapper: DetailLinkWrapper,
  Content: DetailContent,
});

export const OperationDetailHeader = (params: {
  operationData: OperationsGet200ResponseRowsInner;
}) => {
  const {
    name,
    code,
    fromLocationCode,
    fromLocationName,
    toLocationCode,
    toLocationName,
    siteCode,
    createdAt,
    creatorUserCode,
  } = params.operationData || {};

  const { openModal } = useModal();
  const { t } = useTranslation();

  return (
    <DetailOperation>
      <DetailOperation.Title>
        {name} ({code})
      </DetailOperation.Title>
      <Space h="md" />
      <DetailOperation.Field>
        <DetailOperation.Label>{t("site.code")}</DetailOperation.Label>
        <DetailOperation.Content>{siteCode}</DetailOperation.Content>
      </DetailOperation.Field>
      <DetailOperation.Field>
        <DetailOperation.Label>{t("operation.code")}</DetailOperation.Label>
        <DetailOperation.Content>{code}</DetailOperation.Content>
      </DetailOperation.Field>
      <DetailOperation.Field>
        <DetailOperation.Label>{t("operation.fromLocationCode")}</DetailOperation.Label>
        <DetailOperation.Content>
          <DetailOperation.Link
            onClick={() =>
              openModal(<LocationDetailForm locationCode={fromLocationCode} />, null, "")
            }
          >
            {fromLocationCode}
          </DetailOperation.Link>
        </DetailOperation.Content>
      </DetailOperation.Field>
      <DetailOperation.Field>
        <DetailOperation.Label>{t("operation.fromLocationName")}</DetailOperation.Label>
        <DetailOperation.Content>{fromLocationName}</DetailOperation.Content>
      </DetailOperation.Field>
      <DetailOperation.Field>
        <DetailOperation.Label>{t("operation.toLocationCode")}</DetailOperation.Label>
        <DetailOperation.Content>
          <DetailOperation.Link
            onClick={() =>
              openModal(<LocationDetailForm locationCode={toLocationCode} />, null, "")
            }
          >
            {toLocationCode}
          </DetailOperation.Link>
        </DetailOperation.Content>
      </DetailOperation.Field>
      <DetailOperation.Field>
        <DetailOperation.Label>{t("operation.toLocationName")}</DetailOperation.Label>
        <DetailOperation.Content>{toLocationName}</DetailOperation.Content>
      </DetailOperation.Field>
      <DetailOperation.Field>
        <DetailOperation.Label>
          {t("user.creatorUserCode")} ({t("user.created")})
        </DetailOperation.Label>
        <DetailOperation.Content>
          {creatorUserCode} ({createdAt ? DatetimeUtil(createdAt) : ""})
        </DetailOperation.Content>
      </DetailOperation.Field>
    </DetailOperation>
  );
};
